import React, {useEffect, useState} from 'react';
import {Button, FormGroup, InputGroup, InputGroupAddon, Row, Table} from 'reactstrap';
import {ColumnSort, MyPagination, SearchMemberItems} from '../index';
import {myDispatch, registerDispatch} from '../../actions/util';
import {connect} from 'react-redux';
import * as types from "../../types";
import {getMembersAction} from '../../actions/member';

const SearchMemberList = ({
                            isFetching,
                            event,
                            members,
                            paginationSearchMember,
                            changeSortAction,
                            registrationType,
                            isWalkInMember,
                            getMembersAction
                          }) => {
  const filterStyle = {
    border: '1px dashed #e9e9e9',
    borderRadius: '6px',
    padding: '.25rem .25rem 0',
    // marginBottom: '5px',
    backgroundColor: '#fafafa'
  };

  useEffect(() => {
    getMembersAction(10, 0);
    // eslint-disable-next-line
  }, [getMembersAction]);

  const [filter, setFilter] = useState('');


  let items = [];


  if (members.length) {
    for (let i in members) {
      items.push(
        <SearchMemberItems
          key={'group-item' + i}
          member={members[i]}
          index={i}
          event={event}
          registrationType={registrationType}
          isWalkInMember={isWalkInMember}

        />
      );
    }
  }

  return (
    <div style={{width: '100%'}}>
      <div style={filterStyle}>
        <Row style={{width: '100%', alignItems: 'center'}}>
          <FormGroup style={{height: '26px'}} className='col-12 col-md-10'>
            <InputGroup>
              <input
                type='text'
                value={filter}
                name='filterName'
                className='form-control col-12'
                placeholder='Search by...'
                onChange={e => {
                  setFilter(e.target.value);
                }}
                onKeyUp={e => {
                  if (e.keyCode === 27) {
                    setFilter('');
                    getMembersAction();
                  }
                  if (e.keyCode === 13) {
                    setFilter(e.target.value);
                    getMembersAction(
                      undefined,
                      undefined,
                      e.target.value
                    );
                  }
                }}
              />
              <InputGroupAddon addonType='append'>
                <Button
                  outline
                  color='primary'
                  onClick={() => {
                    getMembersAction(
                      undefined,
                      undefined,
                      filter
                    );
                  }}
                >
                  Search
                </Button>
                <Button
                  outline
                  color='primary'
                  onClick={() => {
                    setFilter('');
                    getMembersAction();
                  }}
                >
                  Reset
                </Button>
              </InputGroupAddon>
            </InputGroup>
          </FormGroup>
        </Row>
      </div>
      <div>
        <div>
          <div
            className='float-right'
            style={{padding: '0px 3px 0px', height: '20px'}}
          >
            {paginationSearchMember.count > members.length &&
            paginationSearchMember.skip + 1 + ' to '}
            {paginationSearchMember.skip + members.length}
            {paginationSearchMember.count > members.length &&
            ' of ' + paginationSearchMember.count}
            &nbsp;{members.length === 1 ? 'record' : 'records'}
          </div>
        </div>
        <Table responsive className='col-12'>
          <thead>
          <tr className='card-header'>
            <th>First Name<ColumnSort columnName="Frstname" columnSort={paginationSearchMember.columnSort} descending={paginationSearchMember.descending} changeSortAction={(object) => {
              changeSortAction({...paginationSearchMember, ...object});
              getMembersAction(paginationSearchMember.limit, paginationSearchMember.skip, paginationSearchMember.filter, object.columnSort, object.descending)
            }}/></th>
            <th>Last Name<ColumnSort columnName="Lastname" columnSort={paginationSearchMember.columnSort} descending={paginationSearchMember.descending} changeSortAction={(object) => {
              changeSortAction({...paginationSearchMember, ...object});
              getMembersAction(paginationSearchMember.limit, paginationSearchMember.skip, paginationSearchMember.filter, object.columnSort, object.descending)
            }}/></th>
            <th>File No. <ColumnSort columnName="Fileno" columnSort={paginationSearchMember.columnSort} descending={paginationSearchMember.descending} changeSortAction={(object) => {
              changeSortAction({...paginationSearchMember, ...object});
              getMembersAction(paginationSearchMember.limit, paginationSearchMember.skip, paginationSearchMember.filter, object.columnSort, object.descending)
            }}/></th>
            <th>Title<ColumnSort columnName="Title" columnSort={paginationSearchMember.columnSort} descending={paginationSearchMember.descending} changeSortAction={(object) => {
              changeSortAction({...paginationSearchMember, ...object});
              getMembersAction(paginationSearchMember.limit, paginationSearchMember.skip, paginationSearchMember.filter, object.columnSort, object.descending)
            }}/></th>
            <th>Site Code <ColumnSort columnName="Sitecode" columnSort={paginationSearchMember.columnSort} descending={paginationSearchMember.descending} changeSortAction={(object) => {
              changeSortAction({...paginationSearchMember, ...object});
              getMembersAction(paginationSearchMember.limit, paginationSearchMember.skip, paginationSearchMember.filter, object.columnSort, object.descending)
            }}/></th>
            <th/>
          </tr>
          </thead>
          <tbody>
          {members.length ? (
            items
          ) : (
            <tr>
              <th colSpan='6' className='text-center'>
                No content data
              </th>
            </tr>
          )}
          </tbody>
        </Table>
        {members.length > 0 && paginationSearchMember.limit < paginationSearchMember.count && (
          <MyPagination
            count={paginationSearchMember.count}
            limit={paginationSearchMember.limit}
            skip={paginationSearchMember.skip}
            action={skip => {
              getMembersAction(paginationSearchMember.limit, skip, filter, paginationSearchMember.columnSort, paginationSearchMember.descending);
            }}
          />
        )}

      </div>
    </div>
  );
};

const mapStateToProps = ({isFetching, getMembers, paginationSearchMember}) => ({
  isFetching,
  members: getMembers,
  paginationSearchMember
});

const mapDispatchProps = dispatch => {
  registerDispatch(dispatch);
  return {
    getMembersAction,
    changeSortAction: (data) => {
      dispatch(myDispatch(types.ADD_MEMBERSEARCH_PAGINATION, {data}));
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchProps
)(SearchMemberList);